import { t } from "@web-monorepo/i18n/macro";
import ShadowCard from "src/shared/components/ShadowCard";
import Header from "./Header";
import styles from "./TeacherTips.module.css";

type TeacherTipsProps = {
  tips: string[];
  onClose: () => void;
};

export default function TeacherTips({ tips, onClose }: TeacherTipsProps) {
  return (
    <div>
      <Header onClose={onClose} title={t`Teacher Tips`} />
      <div className={styles.app}>
        {tips.map((tip, index) => (
          <ShadowCard className={styles.card} key={index.toString()}>
            {tip}
          </ShadowCard>
        ))}
      </div>
    </div>
  );
}
